import {
    IAnimationControllerConfiguration,
    Inject,
    ISimpleControllerConfiguration,
    SimpleBaseController,
} from '@denishussar/html5-game-engine';
import { GameModel, GameMoveableObstacleTypeEnum, PlayerRoadIndexEnum } from '../../../../Models/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';
import { Graphics, Point } from 'pixi.js';
import { remapValue, sampleFromArray } from '../../../../Common/Utils';

export interface IGameMoveableObstacleProjectionControllerOptions {
    type: GameMoveableObstacleTypeEnum;
    index: number;
    roadIndex: number;
}

export class GameMoveableObstacleProjectionController extends SimpleBaseController {
    $model: GameModel;

    public policeSwapedLine: boolean = false;
    public gelikSwapedLines: number = 1;

    private _projectionScale: number[] = [0.3, 8];

    private _type: GameMoveableObstacleTypeEnum = GameMoveableObstacleTypeEnum.none;
    private _index: number = 0;
    private _roadIndex: number = 0;

    private _roadIndexChangeCounter: number = 0;
    private _roadIndexChangeTime: number = 0;
    private _roadIndexChangeTimeInitial: number = 1;

    private _size: number = 8;
    private _graphics: Graphics;

    private _roadLineWidth: number = 0;

    private _roadLineOffset: number = undefined;
    private _roadLineTargetOffset: number = undefined;
    private _roadLineOffsetChangeSpeed: number = 0.1;

    private _roadMarginPoint: Point = new Point();
    private _roadLocalMarginDirection: number = 1;

    public constructor(
        @Inject private _options: IGameMoveableObstacleProjectionControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('GameMoveableObstacleProjectionController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        this._type = this._options.type;
        this._index = this._options.index;
        this._roadIndex = this._options.roadIndex;

        return <ISimpleControllerConfiguration>{};
    }

    protected onInitialize(): void {
        this._roadLocalMarginDirection = sampleFromArray([1, -1]);
        this.visible = false;
        // this._graphics = new Graphics();
        // this._graphics.beginFill(0x00ff00);
        // this._graphics.drawCircle(0, 0, this._size);
        // this._graphics.endFill();

        // this._roadIndexChangeTime = this._roadIndexChangeTimeInitial;

        // this.visible = false;// set true for debug

        // this.display.addChild(this._graphics);
    }

    protected onDestroy() {


        super.onDestroy();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    protected onUpdate(frameRate: number) {
        const globalPoint = this.display.parent.toGlobal(this.display.position);

        this.display.scale.set(remapValue(globalPoint.y,
            this.renderer.renderer.height * 0.3, this.renderer.renderer.height,
            this._projectionScale[0], this._projectionScale[1],
        ));

        // switch (this._type) {
        //     case GameMoveableObstacleTypeEnum.policeCrown:
        //     case GameMoveableObstacleTypeEnum.police:
        //         if (this._roadIndexChangeCounter === 0) {
        //             this.updateSwapRoadIndex(frameRate);
        //         }
        //         break;

        //     case GameMoveableObstacleTypeEnum.gelandewagen:
        //         this.updateSwapRoadIndex(frameRate);
        //         break;
        // }
    }

    public updateSwapRoadIndex(frameRate: number): void {
        if (this._roadIndexChangeTime === 0) {
            if (this._type === GameMoveableObstacleTypeEnum.gelandewagen)
                this.swapRoadIndex();
            else
                this._roadIndex = this.$model.playerRoadIndex;
            this._roadIndexChangeTime = this._roadIndexChangeTimeInitial;
            this._roadIndexChangeCounter++;

        } else {
            this._roadIndexChangeTime = Math.max(0, this._roadIndexChangeTime - frameRate);
        }
    }

    public swapRoadIndex(): void {
        if (this._type == GameMoveableObstacleTypeEnum.gelandewagen) {
            switch (this._roadIndex) {
                case PlayerRoadIndexEnum.center:
                    this._roadIndex = sampleFromArray([PlayerRoadIndexEnum.left, PlayerRoadIndexEnum.right]);
                    break;

                case PlayerRoadIndexEnum.left:
                case PlayerRoadIndexEnum.right:
                    this._roadIndex = PlayerRoadIndexEnum.center;
                    break;
            }

            this.setRoadLineTargetOffset(this.getRoadLineWidth() * this._roadIndex);
        }
        else{
            this._roadIndex = this.$model.playerRoadIndex;
        }

    }

    public getIndex(): number {
        return this._index;
    }

    public getRoadIndex(): number {
        return this._roadIndex;
    }

    public setRoadLineWidth(value: number): void {
        this._roadLineWidth = value;
    }

    public getRoadLineWidth(): number {
        return this._roadLineWidth;
    }

    public setRoadLineOffset(value: number): void {
        this._roadLineOffset = value;
    }

    public setRoadLineTargetOffset(value: number): void {
        this._roadLineTargetOffset = value;
    }

    public setRoadMarginPoint(value: Point): void {
        this._roadMarginPoint.copy(value);
    }

    public getRoadMarginPoint(): Point {
        return this._roadMarginPoint;
    }

    public getRoadLineOffset(): number {
        return this._roadLineOffset;
    }

    public getRoadLineTargetOffset(): number {
        return this._roadLineTargetOffset;
    }

    public getRadLineOffsetChangeSpeed(): number {
        return this._roadLineOffsetChangeSpeed;
    }

    public getRoadLocalMarginDirection(): number {
        return this._roadLocalMarginDirection;
    }
}
